<template>
  <footer class="site-footer">
    <div class="footer-content">
      <div v-for="column in footerColumns" :key="column.id" class="footer-column">
        <h3>{{ column.title }}</h3>
        <ul>
          <li v-for="link in column.links" :key="link.to">
            <router-link :to="link.to">{{ link.label }}</router-link>
          </li>
        </ul>
      </div>
    </div>
    <p class="footer-tagline">{{ siteMeta.tagline }}</p>
  </footer>
</template>

<script>
import { FOOTER_COLUMNS, SITE_META } from '@/config/siteFooter'

export default {
  name: 'FooterView',
  data() {
    return {
      footerColumns: FOOTER_COLUMNS,
      siteMeta: SITE_META
    }
  }
}
</script>

<style scoped>
.site-footer {
  background: linear-gradient(180deg, #3d4f4a 0%, #2f3b38 100%);
  padding: 36px 0 20px;
  margin-top: 32px;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 24px;
  padding: 0 20px;
}

.footer-column h3 {
  color: #eef9f3;
  font-size: 16px;
  margin: 0 0 14px;
  font-weight: 600;
}

.footer-column ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-column ul li {
  margin-bottom: 10px;
}

.footer-column a {
  color: rgba(255, 255, 255, 0.78);
  text-decoration: none;
  font-size: 14px;
  transition: color 0.2s;
}

.footer-column a:hover {
  color: #42b983;
}

.footer-tagline {
  max-width: 1200px;
  margin: 20px auto 0;
  padding: 0 20px;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.55);
  text-align: center;
}

@media (max-width: 767px) {
  .site-footer {
    display: none;
  }
}
</style>
